import { z } from 'zod';

const bytes = z.array(z.number().int().min(0).max(255));
const encrypted = z.object({ iv: bytes.length(12), ciphertext: bytes.min(16) });
export const eventVaultExportSchema = z.object({
  format: z.literal('meridian-event-vault'),
  version: z.literal(1),
  metadata: z.object({
    scope: z.string(), version: z.literal(1), keyId: z.string().uuid(),
    expiresAt: z.string().datetime(), salt: bytes.length(16), wrappedKey: encrypted,
  }),
  records: z.array(z.object({ id: z.string(), scope: z.string(), value: encrypted, settled: z.boolean().optional() })),
});
